<template>
  <div class="w-100">
    <h3>Role Details</h3>
    <hr />
    <div class="d-flex flex-row justify-content-between my-4">
      <div>
        <label style="font-size: 16px; font-weight: 400; color: #383f51" for="role-name">Role Name</label>
        <base-input v-model="roleName" style="width: 476.5px"></base-input>
        <div v-if="roleErrors.name" class="text-danger mt-1" style="font-size: 13px;">
          {{ roleErrors.name }}
        </div>
      </div>

      <div>
        <label style="font-size: 16px; font-weight: 400; color: #383f51" for="role-name">Role Description </label>
        <base-input v-model="roleDescription" style="width: 476.5px"></base-input>
        <div v-if="roleErrors.description" class="text-danger mt-1" style="font-size: 13px;">
          {{ roleErrors.description }}
        </div>
      </div>
    </div>

    <hr style="border-top: dashed 1.5px #c5c4d4" class="text-muted" />

    <div class="my-3">
      <h2>Access Control</h2>
      <hr class="my-3" />
      <div class="d-flex flex-row my-3 justify-content-between">
        <p class="my-auto">
          Select which modules and associated actions/forms to grant access to.
        </p>
        <span>
          <base-button text="+ Add Modules" background="white" class="text-success"
            @click="showAddModuleModal = true"></base-button>

          <button style="width: 157px; height: 48px" @click="importPrivilegeModal = true"
            class="border-2 border-black rounded py-1 px-2 font-normal mr-4">
            Import Privileges
          </button>
        </span>
      </div>
    </div>

    <div v-if="selectedRoleObjects.length">
      <ModuleRole v-for="(selectedAppModule, index) in selectedRoleObjects" :index="index"
         :appModule="selectedAppModule" @selectedPrivileges="setPrivileges" :selectedPrivileges="selectedPrivileges"
        :key="index" />
    </div>
  



    <div class="w-100">
      <div class="d-flex flex-row-reverse" style="margin-top: 214px">
        <base-button :loading="isSubmitting" @click="editModule && editModule.id ? updateRole() : createRole()"
          style="width: 157px; height: 48px" :text="editModule && editModule.id ? 'Update' : 'Save'">
        </base-button>

        <button style="width: 157px; height: 48px" @click="$emit('cancelEdit')"
          class="border-2 border-black rounded py-1 px-2 font-normal mr-4">
          Cancel
        </button>
      </div>
    </div>

    <!-- Add module modal -->
    <modal @close-modal="showAddModuleModal = false" :showModal="showAddModuleModal" width="585" :arrowTitle="true"
      title="Add Module">

      <div class="flex justify-between items-center module-wrapper">

        <p class="my-3">Grant access to select modules.</p>
        <label class="pt-2" for="">Access All Modules</label>
        <b-form-checkbox class="uniform-checkbox" v-model="selectAllModules"></b-form-checkbox>
      </div>
      <hr class="text-muted" style="border-top: dashed 1px" />
      <div class="my-3">
        <loader v-if="loadingPrivileges" />

        <b-form-group v-else v-slot="{ ariaDescribedby }">
          <b-form-checkbox-group id="checkbox-group-2" v-model="tempSelectedAppModules"
            :aria-describedby="ariaDescribedby" name="module">
            <div v-for="(appModule, i) in appModules" :key="i"
              class="d-flex flex-row justify-content-between border py-1 pl-2">
              <label class="my-auto" for="">{{ appModule.name }}</label>
              <b-form-checkbox class="my-auto uniform-checkbox" :value="appModule.name"></b-form-checkbox>
            </div>
          </b-form-checkbox-group>
        </b-form-group>
      </div>

      <div class="d-flex flex-row-reverse" style="margin-top: 200px">
        <base-button text="Save" @click="saveModule"></base-button>

        <button style="width: 157px; height: 48px" @click="showAddModuleModal = false"
          class="border border-black rounded py-1 px-2 font-normal mr-4">
          Close
        </button>
      </div>
    </modal>

    <!-- Import Privilege  modal -->
    <modal @close-modal="importPrivilegeModal = false" :showModal="importPrivilegeModal" width="585" :arrowTitle="false"
      title="Import Privileges">
      <p class="my-3">Import access control settings from existing role.</p>
      <hr class="long-dash" />
      <div class="my-3">
        <div class="my-3">
          <label for="" class="left-label">Role Name</label>


          <el-select v-model="selectedRole" placeholder="Select" @change="setSelectedPrivileges">
            <el-option v-for="(role, index) in roles" :key="role.id || index" :label="role.name" :value="role">
            </el-option>
          </el-select>
        </div>



        <div class="d-flex flex-row justify-between mb-5 all-priviledges">
          <span style="font-size: 12px; font-weight: 400">{{ attachedModules }} Selected</span>

          <div class="d-flex flex-row justify-between" v-if="selectedRole">
            <label class="mx-2" for="">Import All Priviledges</label>

            <b-form-checkbox />
          </div>
        </div>

        <b-form-group v-slot="{ ariaDescribedby }">
          <b-form-checkbox-group id="checkbox-group-2" v-model="tempImportSelectedAppModules"
            :aria-describedby="ariaDescribedby" name="module">
            <div v-for="(roleAppModule, i) in roleAppModules" :key="i"
              class="d-flex flex-row justify-content-between border py-2 pl-2">
              <label class="my-auto font-semibold" for="">{{
                roleAppModule.name
              }}</label>

              <b-form-checkbox class="my-auto" :value="roleAppModule.name"></b-form-checkbox>
            </div>
          </b-form-checkbox-group>
        </b-form-group>
      </div>
      <div class="d-flex flex-row-reverse" style="margin-top: 200px">
        <base-button @click="saveModule" text="Save"></base-button>

        <button style="width: 157px; height: 48px" @click="importPrivilegeModal = false"
          class="border border-black rounded py-1 px-2 font-normal mr-4">
          Close
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import moment from "moment";
import Modal from "./Modal.vue";
import ModuleRole from "./ModuleRole.vue";



export default {
  components: {
    Modal,
    ModuleRole,

  },
  props: {
    editModule: {
      type: Object,

      default: () => ({}),

    },
    isNewRole: { type: Boolean },
  },
  data() {
    return {
      endDate: "",  
      importPrivilegeModal: false,
      showAddModuleModal: false,
      selectedPrivileges: [],
      modulePrivilegesMap: {},// per-module storage
      tempImportSelectedAppModules: [],
      roleName: "",
      roleDescription: "",
      isSubmitting: false,
      roles: [],
      privileges: null,
      appModules: [],
      loadingPrivileges: false,
      tempSelectedAppModules: [],
      selectedAppModules: [],
      appModule: null,
      selectedPrivilegeIds: [],
      selectAllModules: false,
      selectedRole: null,
      roleAppModules: [],
      attachedModules: 0,
      id: undefined,
      roleErrors: {
        name: '',
        description: ''
      },

      loadingRoleAppModules: false,
    };
  },
  mounted() {
    this.getRoles();
    this.getModules();
  },

  watch: {
    selectAllModules(newVal) {
      if (newVal) {
        this.tempSelectedAppModules = this.appModules.map(m => m.name);
      } else {
        this.tempSelectedAppModules = [];
      }
    },
    editModule: {
      handler(newVal) {
        if (newVal && newVal?.id) {
          this.roleName = newVal?.name || '';
          this.roleDescription = newVal?.description || '';
          this.selectedAppModules = (newVal?.modules || []).map(module => module.name) || '';

          this.selectedPrivileges = [];
          this.modulePrivilegesMap = {};

          (newVal?.modules || []).forEach(module => {
            (module?.submodules || []).forEach(submodule => {
              const privIds = (submodule?.privileges || []).map(p => p.id);
              this.selectedPrivileges.push(...privIds);
              this.modulePrivilegesMap[submodule.slug] = privIds;
            });
          });

          this.selectedPrivileges = [...new Set(this.selectedPrivileges)];


        } else {
          this.resetForm();
        }
      },
      immediate: true,
      deep: true
    }

  },
  computed: {
    selectedRoleObjects() {
      return this.appModules.filter(module =>
        this.selectedAppModules.includes(module.name)
      );
    },
    
      dateFilterpayload() {
      return {
        dateFilter: "custom",
        startDate: "2024-01-01",
        endDate: this.endDate ? moment(this.endDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
      };
    },

    payload() {
      return { privilege: this.selectedPrivileges }
    }
  },
  methods: {
    resetForm() {
      this.roleName = '';
      this.roleDescription = '';
      this.selectedAppModules = [];
      this.selectedPrivileges = [];
      // this.editModule = {};
    },
    setSelectedPrivileges(role) {
      this.selectedRole = role.name;
      this.selectedPrivilegeIds = role.privileges.map(priv => priv.id);
      this.selectedPrivileges = this.selectedPrivilegeIds
      this.roleAppModules = role.modules
      this.attachedModules = this.roleAppModules.length
      this.tempImportSelectedAppModules = this.roleAppModules.map(module => module.name);
    },

    setPrivileges({ moduleSlug, privileges }) {

      this.modulePrivilegesMap[moduleSlug] = privileges;

      // Merge all privileges, remove duplicates
      const combined = Object.values(this.modulePrivilegesMap).flat();
      this.selectedPrivileges = [...new Set(combined)];
    },

    setSelectedModule(val) {
      const array = val.filter((item) =>
        this.editModule?.moduleIds?.includes(item.id)
      );
      this.selectedAppModules = array;
    },


    saveModule() {
      if (this.tempSelectedAppModules.length && this.showAddModuleModal) {
        this.selectedAppModules = this.tempSelectedAppModules;
        this.showAddModuleModal = false;

      }
      else if (this.tempImportSelectedAppModules.length && this.importPrivilegeModal) {
        this.selectedAppModules = this.tempImportSelectedAppModules
        this.importPrivilegeModal = false
      }
    },


    async createRole() {
      this.roleErrors.name = '';
      this.roleErrors.description = '';

      // Simple validation
      if (!this.roleName) {
        this.roleErrors.name = 'Role name is required';
        this.generateToast(this.roleErrors.name, "error");
      }

      if (!this.roleDescription) {
        this.roleErrors.description = 'Role description is required';
        this.generateToast("Role description is required", "error");
      }

      // Stop if there are any validation errors
      if (this.roleErrors.name || this.roleErrors.description) {
        return;
      }

      // Step 2: Custom validation - module & privilege
      if (!this.selectedAppModules.length) {
        this.generateToast("Addition of module is required", "error");
        return;
      }

      if (this.selectedAppModules.length && !this.selectedPrivileges.length) {
        this.generateToast("Select at least one privilege", "error");
        return;
      }
      try {
        this.isSubmitting = true;

        const orgId = localStorage.getItem("organizationId");

        const payload = {
          orgId: orgId,
          name: this.roleName,
          description: this.roleDescription,

        };

        const response = await this.$_createRole({ ...payload, ...this.payload });
        if (response.data.success === true) {
          this.generateToast(response.data.message, "success");
          this.$emit('resetRoles');
          this.resetForm();
        }

      } catch (error) {

        this.generateToast('An error occurred while creating the role.', "error");

      } finally {
        this.isSubmitting = false;
      }
    },

    async updateRole() {
      this.roleErrors.name = '';
      this.roleErrors.description = '';

      if (!this.roleName) {
        this.roleErrors.name = 'Role name is required';
        this.generateToast(this.roleErrors.name, "error");
      }
      if (!this.roleDescription) {
        this.roleErrors.description = 'Role description is required';
        this.generateToast("Role description is required", "error");
      }
      if (this.roleErrors.name || this.roleErrors.description) {
        return;
      }

      try {
        this.isSubmitting = true;


        const payload = {
          id: this.editModule?.id,  // include role ID for update

          name: this.roleName,
          description: this.roleDescription,
          privilege: this.selectedPrivileges,
        };

        const response = await this.$_updateRole(payload);
        if (response.data.success === true) {
          this.resetForm();
          this.generateToast(response.data.message, "success");
          this.$emit('resetRoles');
        }
      } catch (error) {
        this.generateToast('An error occurred while updating the role.', "error");
      } finally {
        this.isSubmitting = false;
      }
    },



    async getModules() {
      try {
        this.loadingPrivileges = true;
        const response = await this.$_getModulesAndPrivileges();
        this.appModules = response.data.data;
      } catch (error) {
        throw new Error(error);
      } finally {
        this.loadingPrivileges = false;
      }
    },
    async getRoles() {
      try {
        const response = await this.$_getRoles(this.dateFilterpayload);
        this.roles = response.data.data;
      } catch (error) {
        throw new Error(error);
      }
    },
  },
};
</script>

<style scoped>
.all-priviledges {
  margin: 0 auto;
  width: 95%;
}

.module-wrapper {

  width: 97%;
}

.module-wrapper>label {

  margin-left: 10%;
}

.uniform-checkbox input[type="checkbox"] {
  width: 10px;
  height: 10px;
  min-width: 18px;
  min-height: 18px;
}

.collapsed>.when-open {
  display: none;
}

.not-collapsed>.when-closed {
  display: none;
}

.left-label {
  width: 100%;
  text-align: right;
  font-weight: 600;
}

.el-select-dropdown__item.selected {
  background-color: white !important;
  font-weight: normal !important;
  color: inherit !important;
}
</style>
